import { client, BASE_URL } from './client';

export const callApi = {
  getRecentCallEvents: (limit = 30) => client.get('get_recent_call_events', { params: { limit } }),
  getVoipAmiConfig: () => client.get('get_voip_ami_config'),
  saveVoipAmiConfig: (params) => client.post('save_voip_ami_config', params),
  getTrunkMappings: () => client.get('get_trunk_mappings'),
  saveTrunkMapping: (params) => client.post('save_trunk_mapping', params),
  deleteTrunkMapping: (trunk_id) => client.post('delete_trunk_mapping', { trunk_id }),
  transferCall: (call_id, target_number, is_mobile = false) => client.post('transfer_call', { call_id, target_number, is_mobile }),
  transferCallToMe: (call_id) => client.post('transfer_call_to_me', { call_id }),
};

export const incomingCallStreamUrl = () => `${BASE_URL}incoming_call_stream`;
